//import packages from node modules
import React, {useCallback, useContext, useEffect, useRef} from "react"
import {useDispatch, useSelector} from "react-redux"
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"
import {change, Field, formValueSelector} from "redux-form"

//import utilities functions
import {
    ADD_PRODUCT_PAGE,
    EDIT_PRODUCT_PAGE,
    getSlugByName
} from "../../../../utilities/function/common"

import {
    getAttributes,
    getPurchaseDomainNamePriceList
} from "../../../../utilities/function/configuration"

import {
    getPriceByBillingCycleID
} from "../../../../utilities/function/billingCycle"

import {
    getPageByURL,
} from "../../../../utilities/function/urlparams"

import {
    renderOnSalePrice,
    onSale,
    renderNormalPrice
} from "../../pricedomain";


import {deleteConfigurationByCID} from "../../../../app/action"
import {requiredFieldValidation} from "../../form/validation"

//import shared components
import PremiumFlag from "../../premiumflag"
import TextField from "../../form/textfield"
import Dropdown from "../../form/dropdown"
import Goback from "../../goback"
import Ellipsis from "../../ellipsis"

//import internals
import {AUTO_RENEW, EPP_CODE, ID_PROTECTION, TRANSFER_RENEW} from "./index"
import {SelectDomainConfigContext} from "./reducer"
import {SELECT_DOMAIN_CONFIG_FORM} from "./SelectDomainConfigForm"
import DomainConfigWarning from "./DomainConfigWarning";
import DomainConfigFields from "./DomainConfigFields";
import DomainConfigUpsell from "./DomainConfigUpsell";

//main component
let DomainConfig = (props) => {

    //vars
    const {item, index, location} = props
    const {domainSearchResult, selectedProduct, billing_cycle_id, order_type} = item
    const initFlag = useRef(false)
    const dispatch = useDispatch()
    const isAdded = useCallback(() => {
        const {uuid} = item
        if (uuid) {
            return true
        }
        return false
    }, [item])
    const formSelector = formValueSelector(SELECT_DOMAIN_CONFIG_FORM)
    const getInputName = useCallback((name) => {
        if (name) {
            const slug = getSlugByName(name)
            return `domain_config[${index}][${slug}]`
        }
        return undefined
    }, [index])
    const {configurations, form,transferRenewValue} = useSelector(state => ({
        configurations: state.app.configurations,
        form: state.form,
        transferRenewValue: formSelector(state,getInputName(TRANSFER_RENEW)),
    }))

    const domainConfigContext = useContext(SelectDomainConfigContext)
    const pageType = getPageByURL(location.search)
    const prevDomain = useRef(0)

    //callback
    const changeDomainCallback = useCallback(()=>{
        const getCurrentDomain = ()=>{
            if(item && item.domainSearchResult){
                const {domain,tld} = item.domainSearchResult
                return domain+tld
            }
            return undefined
        }
        if (pageType === ADD_PRODUCT_PAGE || pageType === EDIT_PRODUCT_PAGE) {
            if (prevDomain.current !== getCurrentDomain()) {
                initFlag.current = false
                prevDomain.current = getCurrentDomain()
            }
        }
    },[pageType,prevDomain,item])
    const initDomainConfig = useCallback(()=>{
        if (!initFlag.current) {
            const {name, selectedProduct, auto_renew, id_protection, epp, domainSearchResult} = item
            const getCustomFieldInput = () => {
                const {custom_fields} = item
                return custom_fields
            }
            if (isAdded()) {
                const domain = name.split('.')
                if (domain && domain.length) {
                    dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName('domain'), domain[0]))
                }
                if (selectedProduct && selectedProduct.attributes) {
                    const {name} = selectedProduct.attributes
                    dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName('tld'), name))
                }
                dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName(AUTO_RENEW), auto_renew))
                dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName(ID_PROTECTION), id_protection))
                dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName(EPP_CODE), epp))
            } else {
                if (domainSearchResult) {
                    const {domain, tld} = domainSearchResult
                    dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName('domain'), domain))
                    dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName('tld'), tld))
                }
            }
            if (selectedProduct && selectedProduct.attributes && getCustomFieldInput()) {
                const {custom_fields} = selectedProduct.attributes
                if (custom_fields && custom_fields.length) {
                    custom_fields.forEach(field => {
                        const {name, id} = field
                        const input = getCustomFieldInput()
                        if (name && input && input.length > 0) {
                            const selectedInput = input.find(item => item.id === id)
                            if (selectedInput && selectedInput.value) {
                                dispatch(change(SELECT_DOMAIN_CONFIG_FORM, getInputName(name), selectedInput.value))
                            }
                        }
                    })
                }
            }
            initFlag.current = true
        }

    },[initFlag, item, dispatch, getInputName, isAdded])

    useEffect(() => {
        changeDomainCallback()
        initDomainConfig()
    }, [changeDomainCallback,initDomainConfig])

    //render
    if (item && billing_cycle_id) {
        const getDomainName = () => {
            const getName = () => {
                if (isAdded()) {
                    const {name} = item
                    const domain = name.split('.')
                    if (domain && domain.length) {
                        return domain[0]
                    }
                    return <></>
                } else {
                    const {domain} = domainSearchResult
                    return domain
                }
            }
            const getTLD = () => {
                if (isAdded()) {
                    const {selectedProduct} = item
                    if (selectedProduct && selectedProduct.attributes) {
                        const {name} = selectedProduct.attributes
                        return name
                    }
                    return (<></>)

                } else {
                    const {tld} = domainSearchResult
                    return tld
                }
            }

            const renderEdit = () => {
                if (pageType === ADD_PRODUCT_PAGE) {
                    return (
                        <Goback
                            onClick={() => {
                                const {setDomainPage} = domainConfigContext
                                if (setDomainPage) {
                                    setDomainPage(0)
                                }
                                if (getName() && getTLD()) {
                                    const cid = getName() + getTLD()
                                    deleteConfigurationByCID(configurations, cid, dispatch)
                                }
                            }}
                            className={'of-select-domain-config-hosting__back'}>
                            Change
                        </Goback>
                    )
                }
            }

            const renderPemiumFlag = () => {
                if(isAdded()){
                    return(<PremiumFlag itemresult={item} />)
                }
                return(<PremiumFlag itemresult={domainSearchResult} />)
            }

            const renderEllipsis = () =>{
                const domain = getName()
                const tld = getTLD()
                const domainname = domain+tld
                const isActive = () => {
                    return domainname && domainname.length>32
                }
                const renderFormat = () =>{
                    const getLast10 = () => {
                        return domain.substring(domain.length -10)
                    }
                    const getFirst10 = () => {
                        return domain.substring(0,10)
                    }
                    return (
                        <div className={'of-domain-config__domainname-wrapper'}>
                            <span className={'domain text-font-3-100'}>{getFirst10()}...{getLast10()}</span>
                            <span className={'tld text-font-1-100'}>{getTLD()}</span>
                        </div>
                    )
                }
                return(
                    <Ellipsis isActive={isActive()} format={renderFormat()} tooltip={domainname} className={'of-domain-config__domainname-ellipsis'} >
                        <span className={'domain text-font-3-100'}>{domain}</span>
                        <span className={'tld text-font-1-100'}>{tld}</span>
                    </Ellipsis>
                )
            }

            return (<div className={'of-domain-config__domain'}>
                {renderEllipsis()}
                {renderPemiumFlag()}
                {renderEdit()}
                <Field name={getInputName('domain')} type={'hidden'} component={TextField}/>
                <Field name={getInputName('tld')} type={'hidden'} component={TextField}/>
            </div>)
        }
        const getPrice = () => {
            if (selectedProduct && getAttributes(selectedProduct)) {
                const {price} = getAttributes(selectedProduct)
                let selectedPrice = getPriceByBillingCycleID(price, billing_cycle_id)
                if (selectedPrice) {
                    const getDropdownList = () => {
                        const getPriceList = () => {
                            const priceList = getPurchaseDomainNamePriceList(item)
                            if (priceList && priceList.length) {
                                return priceList.filter((item) => {
                                    return item.type === order_type
                                })
                            }
                        }
                        let priceList = getPriceList()
                        if (order_type === 'transfer') {
                            if (priceList && priceList.length) {
                                const selectedTranferPrice = priceList.find(i=>i.billing_cycle_id===(transferRenewValue|| billing_cycle_id) && i.type===order_type)
                                priceList = [selectedTranferPrice]
                            }
                        }
                        if (priceList && priceList.length > 0) {
                            const getLabel = (item) => {
                                const {old_price} = item
                                if(onSale(old_price)){
                                    return (renderOnSalePrice(item))
                                }
                                return(renderNormalPrice(item))
                            }
                            return priceList.map(item => ({
                                label: getLabel(item),
                                value: item.billing_cycle_id
                            }))
                        }
                        return []
                    }
                    return (
                        <Field
                            component={Dropdown}
                            list={getDropdownList()}
                            name={getInputName('billing_cycle_id')}
                            initialValue={billing_cycle_id}
                            placeholder={'Billing Cycle'}
                            validate={[requiredFieldValidation]}
                            className={'of-domain-config-billing-cycle'}
                        />
                    )
                }
            }
            return (<></>)
        }
        return (<div className={'of-domain-config'}>
            <div className={`of-domain-config__top lines-border-1-100`}>
                <div className={'of-domain-config__wrapper of-domain-config__wrapper--top'}>
                    {getDomainName()}
                    {getPrice()}
                </div>
            </div>
            <DomainConfigWarning selectedProduct={selectedProduct}
                                 order_type={order_type}/>

            <DomainConfigFields order_type={order_type}
                                selectedProduct={selectedProduct}
                                dispatch={dispatch}
                                form={form}
                                getInputName={getInputName}
                                item={item}/>

            <DomainConfigUpsell item={item}
                                getInputName={getInputName}
                                configurations={configurations}
                                domainConfigContext={domainConfigContext}
                                location={location}/>
        </div>)
    }
    return (<></>)
}
DomainConfig.propTypes = {
    item: PropTypes.any,
    location: PropTypes.any,
    index: PropTypes.number
}
DomainConfig = withRouter(DomainConfig)

export default DomainConfig